import React from "react";

export default function Graph_Google() {
  return (
    <div>
      <h1>Graph_Google</h1>
      <p>This is the Graph_Google component.</p>
    </div>
  );
}
